module.exports = __webpack_public_path__ + "static/media/ic_目录收起.96469c36.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_目录收起.svg
// module id = 201
// module chunks = 0